import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import KeyIcon from "@mui/icons-material/Key";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Menu, MenuItem, ProSidebar } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link, useLocation } from "react-router-dom";
import { tokens } from "../../theme";
import SAMLBroker from "../configuration/samlbroker";

const Item = ({ title, to, icon, selected, setSelected, isCollapsed }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: "white",
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography
        style={{
          bacfontFamily: [
            "Avenir Next W02",
            "Lexend Deca",
            "Helvetica",
            "Arial",
            "sans-serif",
          ].join(","),
          fontWeight: "3rem",
          fontSize: "1rem",
        }}
      >
        {title}
      </Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const [selected, setSelected] = useState("");

  useEffect(() => {
    let curr = location.pathname.split("/")[2];
    if (curr == "app-configurations") {
      setSelected("App Configurations");
    } else if (curr == "pagerestriction") {
      setSelected("Page Restriction");
    } else if (curr == "loginaudit") {
      setSelected("Login Audits");
    } else if (curr == "contact") {
      setSelected("Contact us");
    } else if (curr == "saml-broker"){
      setSelected("HubSpot Enterprise SSO")
    } else if(curr == "account-sso-configuration"){
      setSelected("HubSpot Account SSO")
    }
    else {
      setSelected("");
    }
  }, [location.pathname]);

  return (
    <Box
      // flex="none"
      // align-items="stretch"
      backgroundColor="#263746"
      sx={{
        "& .pro-sidebar-inner": {
          background: `#263746 !important`,
          width: isCollapsed ? "80px !important" : "280px !important",
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#4cceac !important",
          backgroundColor: "transparent !important",
        },

        "& .pro-menu-item.active": {
          color: "#263746 !important",
          backgroundColor: "white !important",
        },
      }}
    >
      <ProSidebar
        collapsed={isCollapsed}
        style={{ backgroundColor: "#263746" }}
      >
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={
              isCollapsed ? (
                <MenuOutlinedIcon style={{ color: "white" }} />
              ) : undefined
            }
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <img
                  alt="miniorange"
                  width="150px"
                  height="40px"
                  src={`${process.env["REACT_APP_FRONTEND_URL"]}/assets/miniorangeimg.webp`}
                  style={{ cursor: "pointer", borderRadius: "" }}
                />
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon style={{ color: "white" }} />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                ></Typography>
                <Typography variant="h5" color={colors.greenAccent[500]}>
                  {localStorage.getItem("username")}
                </Typography>
              </Box>
            </Box>
          )}
          <Box paddingLeft={isCollapsed ? undefined : "0%"}>
            <Item
              title="App Configurations"
              to="/sso/app-configurations"
              icon={<SettingsIcon />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={!isCollapsed}
            />
            <br />
            <Item
              title="HubSpot Enterprise SSO"
              to="/sso/saml-broker"
              icon={<SettingsIcon />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={!isCollapsed}
            />
            <br />
            <Item
              title="HubSpot Account SSO"
              to="/sso/account-sso-configuration"
              icon={<SettingsIcon />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={!isCollapsed}
            />
            <br />
            <Item
              title="Page Restriction"
              to="/sso/pagerestriction"
              icon={<KeyIcon />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={!isCollapsed}
            />
            <br />
            <Item
              title="Login Audits"
              to="/sso/loginaudit"
              icon={<ManageSearchIcon />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={!isCollapsed}
            />
            <br />
            <Item
              title="Contact us"
              to="/sso/contact"
              icon={<ContactSupportIcon />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={!isCollapsed}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
